export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        cognitoSub
        firstName
        lastName
        phone
        email
        emailVerified
        role
        receiveSmsTaskReminders
        receiveEmailTaskReminders
        receiveSmsTaskAssignments
        receiveEmailTaskAssignments
        permissionLogin
        permissionFullAccess
        permissionDocuments
        permissionAccidents
        permissionInjuries
        permissionDrugTests
        permissionDailyRostering
        permissionMessenger
        permissionPerformanceCoaching
        permissionTasksReports
        permissionVehicleManagement
        permissionCustomLists
        permissionManageLabels
        reportsToUserId
        samePersonAsStaffId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getTenant = /* GraphQL */ `
  query GetTenant($id: ID!) {
    getTenant(id: $id) {
      id
      ownerUserId
      users {
        items {
          id
          permissionFullAccess
          permissionLogin
          isCreator
        }
      }
    }
  }
`;

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      group
      cognitoSub
      firstName
      lastName
      phone
      email
      emailAddedToSuppressionListDateTime
      emailVerified
      role
      receiveSmsTaskReminders
      receiveEmailTaskReminders
      receiveSmsTaskAssignments
      receiveEmailTaskAssignments
      permissionLogin
      permissionFullAccess
      permissionDocuments
      permissionManageCounselings
      permissionDeleteCounselings
      permissionAccidents
      permissionInjuries
      permissionDrugTests
      permissionDailyRostering
      permissionMessenger
      permissionPerformanceCoaching
      permissionDAManagement
      permissionCustomLists
      permissionManageLabels
      permissionCompanySettingsRosterChecklistTemplates
      permissionCompanySettingsSchedulingRostering
      permissionMessageTemplate
      permissionTasksReports
      permissionOtherFiles
      permissionVehicleManagement
      permissionVehicleImages
      permissionVehicleRelatedDocuments
      permissionLocationDataFromCompanyDevices
      permissionCompanyDevices
      permissionVehiclePhotoLogs
      permissionAmazonChromePlugin
      permissionPhoneAutomation
      permissionAIChat
      permissionPayrollProvider
      permissionInventoryManagement
      permissionVehiclePhotoLogReview
      reportsToUserId
      samePersonAsStaffId
      permissionDocumentsScope
      permissionManageCounselingsScope
      permissionAccidentsScope
      permissionInjuriesScope
      permissionDrugTestsScope
      permissionPerformanceCoachingScope
      permissionMessengerScope
      rolePermissionOverrides
      zohoCrmContactRecordId
      createdAt
      updatedAt
    }
  }
`;

export const staffsByGroupForLinking = /* GraphQL */ `
  query StaffsByGroup(
    $group: String
    $sortDirection: ModelSortDirection
    $filter: ModelStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    staffsByGroup(
      group: $group
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        status
      }
      nextToken
    }
  }
`;

export const staffReportingHierarchy = /* GraphQL */ `
  query StaffsByGroup(
    $group: String
    $sortDirection: ModelSortDirection
    $filter: ModelStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    staffsByGroup(
      group: $group
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportsToStaffId
      }
      nextToken
    }
  }
`;

export const usersByPhone = /* GraphQL */ `
  query UsersByPhone(
    $phone: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByPhone(
      phone: $phone
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        updatedAt
        group
      }
      nextToken
    }
  }
`;